import { render, staticRenderFns } from "./CNoBlock.vue?vue&type=template&id=2292b2b1&"
import script from "./CNoBlock.vue?vue&type=script&lang=js&"
export * from "./CNoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports